import { useNavigate } from "react-router-dom";

import CalendarMonth from "@mui/icons-material/CalendarMonth";
import HotelIcon from "@mui/icons-material/Hotel";
import { Button, ButtonGroup, Card, CardMedia, Rating, Tooltip, Typography } from "@mui/material";

import { ApiHotelItem } from "@/api/hotel";
import usePlatform from "@/hooks/usePlatform";

import useHotelLink from "../../hooks/useHotelLink";
import useHotelPrice from "../../hooks/usePrice";

const Info = (props: {
  data: ApiHotelItem;
  onMouseEnter: () => void;
  onMouseLeave: () => void;
}) => {
  const { data } = props;

  const { pointPrice, pointValue, isSearchData } = useHotelPrice(props.data);
  const { isMobile } = usePlatform();

  const navigator = useNavigate();

  const { getHotelLink } = useHotelLink();
  return (
    <div
      className="min-w-[240px]"
      onMouseEnter={props.onMouseEnter}
      onMouseLeave={props.onMouseLeave}
    >
      <CardMedia sx={{ height: 96 }} image={data.image} title="green iguana" />
      <div className="p-[10px]">
        <Typography gutterBottom className="text-ellipsis whitespace-nowrap overflow-hidden">
          {data.name}
        </Typography>
        <div className="flex items-center mb-[5px]">
          <Typography variant="body2">{data.g_rating}</Typography>
          <Rating
            className="px-[5px]"
            size="small"
            name="read-only"
            value={Number(data.g_rating)}
            readOnly
            precision={0.1}
          />
          <Typography variant="body2">
            ({data?.g_rating_total.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") || 0})
          </Typography>
        </div>
        <div className="flex mb-[5px]">
          <Typography fontSize={14} className="!mr-[3px]">
            {isSearchData ? "Cash Price:" : "Point Value:"}
          </Typography>
          <Tooltip title={"min - median - max"} placement="top" arrow>
            <Typography fontSize={14}>{pointValue}</Typography>
          </Tooltip>
        </div>

        <div className="flex mb-[5px]">
          <Typography fontSize={14} className="!mr-[4px]">
            Point Price:{" "}
          </Typography>
          <Tooltip title={"min - median - max"} placement="top" arrow>
            <Typography fontSize={14}>{pointPrice}</Typography>
          </Tooltip>
        </div>
        {data.book_info ? <ButtonGroup fullWidth size="small" aria-label="Small button group pr-[4px]">
          <Button
            key="one"
            className="flex items-center"
            onClick={() => {
              if (isMobile) {
                navigator(`/hotel/details?id=${encodeURIComponent(data.id)}`);
              } else {
                window.open(`/hotel/details?id=${encodeURIComponent(data.id)}`, "_blank");
              }
            }}
          >
            <CalendarMonth color="primary" className="mr-[4px]" /> Calendar
          </Button>

          <Button
            key="two"
            className="flex items-center"
            onClick={() => {
              const hotel_link = getHotelLink(data);
              if (hotel_link) {
                window.open(hotel_link, "_blank");
                return;
              }
            }}
          >
            <HotelIcon color="primary" className="mr-[4px]" /> Book
          </Button>

        </ButtonGroup> : <ButtonGroup fullWidth size="small" aria-label="Small button group pr-[4px]">
          <Button
            key="one"
            className="flex items-center"
            onClick={() => {
              if (isMobile) {
                navigator(`/hotel/details?id=${encodeURIComponent(data.id)}`);
              } else {
                window.open(`/hotel/details?id=${encodeURIComponent(data.id)}`, "_blank");
              }
            }}
          >
            <CalendarMonth color="primary" className="mr-[4px]" /> Calendar
          </Button>
        </ButtonGroup>}
      </div>
    </div>
  );
};

const CardInfo = (props: { data: ApiHotelItem }) => {
  return (
    <Card sx={{ maxWidth: 345, borderRadius: "14px" }} variant="outlined">
      <Info data={props.data} />
    </Card>
  );
};

export { CardInfo, Info };
